
define('text!Magento_ReCaptchaCheckout/template/payment-recaptcha-container.html',[],function () { return '<!--\n/**\n * Copyright © Magento, Inc. All rights reserved.\n * See COPYING.txt for license details.\n */\n -->\n<div>\n    <each args="data: getRegion(\'place-order-recaptcha\'), as: \'recaptcha\'" render=""></each>\n</div>\n<hr />\n';});

